export enum SettingsPageTabs {
    accountInfo = 'accountInfo',
    settings = 'accountSettings',
    caseData = 'caseData',
    parties = 'parties',
    users = 'users',
}
